module.exports = __webpack_public_path__ + "media/flags/sl-8a10faab.svg";